export default {
    MUNICIPE: 1,
    PROVISORIO: 2,
    OUTRO_MUNICIPIO: 3
}